/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { CreateDefinitionDtoDefinitionLabel } from './CreateDefinitionDtoDefinitionLabel';
import {
    CreateDefinitionDtoDefinitionLabelFromJSON,
    CreateDefinitionDtoDefinitionLabelFromJSONTyped,
    CreateDefinitionDtoDefinitionLabelToJSON,
} from './CreateDefinitionDtoDefinitionLabel';
import type { CreateDefinitionParameterDtoValueType } from './CreateDefinitionParameterDtoValueType';
import {
    CreateDefinitionParameterDtoValueTypeFromJSON,
    CreateDefinitionParameterDtoValueTypeFromJSONTyped,
    CreateDefinitionParameterDtoValueTypeToJSON,
} from './CreateDefinitionParameterDtoValueType';
import type { DefinitionParameterDtoOrigin } from './DefinitionParameterDtoOrigin';
import {
    DefinitionParameterDtoOriginFromJSON,
    DefinitionParameterDtoOriginFromJSONTyped,
    DefinitionParameterDtoOriginToJSON,
} from './DefinitionParameterDtoOrigin';

/**
 * 
 * @export
 * @interface DefinitionParameterDto
 */
export interface DefinitionParameterDto {
    /**
     * 
     * @type {string}
     * @memberof DefinitionParameterDto
     */
    id: string;
    /**
     * 
     * @type {CreateDefinitionParameterDtoValueType}
     * @memberof DefinitionParameterDto
     */
    valueType?: CreateDefinitionParameterDtoValueType | null;
    /**
     * 
     * @type {number}
     * @memberof DefinitionParameterDto
     */
    decimalPlaces?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DefinitionParameterDto
     */
    inputRangeMin?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DefinitionParameterDto
     */
    inputRangeMax?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DefinitionParameterDto
     */
    unitId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DefinitionParameterDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof DefinitionParameterDto
     */
    description?: string | null;
    /**
     * 
     * @type {DefinitionParameterDtoOrigin}
     * @memberof DefinitionParameterDto
     */
    origin?: DefinitionParameterDtoOrigin | null;
    /**
     * 
     * @type {CreateDefinitionDtoDefinitionLabel}
     * @memberof DefinitionParameterDto
     */
    definitionLabel?: CreateDefinitionDtoDefinitionLabel | null;
    /**
     * 
     * @type {string}
     * @memberof DefinitionParameterDto
     */
    parameterIdentifier?: string;
    /**
     * 
     * @type {string}
     * @memberof DefinitionParameterDto
     */
    $type?: DefinitionParameterDtoTypeEnum;
}


/**
 * @export
 */
export const DefinitionParameterDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedDataTypeManagementDtoNumericDtoDefinitionParameterDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.NumericDto.DefinitionParameterDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type DefinitionParameterDtoTypeEnum = typeof DefinitionParameterDtoTypeEnum[keyof typeof DefinitionParameterDtoTypeEnum];


/**
 * Check if a given object implements the DefinitionParameterDto interface.
 */
export function instanceOfDefinitionParameterDto(value?: unknown): value is DefinitionParameterDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(DefinitionParameterDtoTypeEnum)[0];
}

export function DefinitionParameterDtoFromJSON(json: any): DefinitionParameterDto {
    return DefinitionParameterDtoFromJSONTyped(json, false);
}

export function DefinitionParameterDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DefinitionParameterDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'valueType': !exists(json, 'valueType') ? undefined : CreateDefinitionParameterDtoValueTypeFromJSON(json['valueType']),
        'decimalPlaces': !exists(json, 'decimalPlaces') ? undefined : json['decimalPlaces'],
        'inputRangeMin': !exists(json, 'inputRangeMin') ? undefined : json['inputRangeMin'],
        'inputRangeMax': !exists(json, 'inputRangeMax') ? undefined : json['inputRangeMax'],
        'unitId': !exists(json, 'unitId') ? undefined : json['unitId'],
        'name': json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'origin': !exists(json, 'origin') ? undefined : DefinitionParameterDtoOriginFromJSON(json['origin']),
        'definitionLabel': !exists(json, 'definitionLabel') ? undefined : CreateDefinitionDtoDefinitionLabelFromJSON(json['definitionLabel']),
        'parameterIdentifier': !exists(json, 'parameterIdentifier') ? undefined : json['parameterIdentifier'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function DefinitionParameterDtoToJSON(value?: DefinitionParameterDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value.id,
        'valueType': CreateDefinitionParameterDtoValueTypeToJSON(value.valueType),
        'decimalPlaces': value.decimalPlaces,
        'inputRangeMin': value.inputRangeMin,
        'inputRangeMax': value.inputRangeMax,
        'unitId': value.unitId,
        'name': value.name,
        'description': value.description,
        'origin': DefinitionParameterDtoOriginToJSON(value.origin),
        'definitionLabel': CreateDefinitionDtoDefinitionLabelToJSON(value.definitionLabel),
        'parameterIdentifier': value.parameterIdentifier,
        '$type': value.$type,
    });
}

